import _ from "lodash";

export function replaceDynamicVariables(sourceDict, currentValue) {
  if (_.isPlainObject(currentValue)) {
    for (const key in currentValue) {
      if (currentValue.hasOwnProperty(key)) {
        currentValue[key] = replaceDynamicVariables(
          sourceDict,
          currentValue[key]
        );
      }
    }
  } else if (Array.isArray(currentValue)) {
    for (let i = 0; i < currentValue.length; i++) {
      currentValue[i] = replaceDynamicVariables(sourceDict, currentValue[i]);
    }
  } else if (typeof currentValue === "string") {
    const matches = currentValue.match(/{%(.*?)%}|\{\{\$(.*?)\}\}/g) || [];
    matches.forEach((match) => {
      const keyMatch = match.match(/{%(.*?)%}|\{\{\$(.*?)\}\}/);
      const key = keyMatch[1] || keyMatch[2] || "";
      const notFoundMessage = "";
      let value = _.get(
        sourceDict,
        key,
        _.get(sourceDict, key.toLowerCase(), notFoundMessage)
      );
      currentValue = currentValue.replace(match, String(value));
    });
  }

  return currentValue;
}
